/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Import_Status_ReadyInputs */



/**
* | output |
* | --- |
* | "Ready" |
*
* @param {Team_Manager_Import_Status_ReadyInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_import_status_ready = /** @type {((inputs?: Team_Manager_Import_Status_ReadyInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Import_Status_ReadyInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Prêt")
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereit")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pronto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Готово")
	if (locale === "es") return /** @type {LocalizedString} */ ("Listo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("就绪")
	if (locale === "ja") return /** @type {LocalizedString} */ ("準備完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("तैयार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pronto")
	return /** @type {LocalizedString} */ ("Ready")
});